import React from "react";
import styles from "./Home.module.css";
import Typical from "react-typical";
import { Link } from "react-router-dom";
import InstallButton from "../../Components/InstallButton/InstallButton";

const Home = () => {
  return (
    <section className={styles.homeContainer}>

      <div className={styles.pageWrapper}>

        {/* HERO */}
        <div className={styles.hero}>
          <Typical
            className={styles.h1}
            steps={[1000, "Fohattech"]}
            loop={Infinity}
            wrapper="h1"
          />

          <p className={styles.subtitle}>
            Ferramentas web simples, rápidas e úteis — direto no navegador.
          </p>

          <Link to="/ferramentas" className={styles.ctaButton}>
            Explorar Ferramentas
          </Link>
        </div>

        <div className={styles.installBox}>
          <h2>📲 Instale nosso app</h2>
          <p>
            Tenha acesso rápido a todas as ferramentas direto no seu celular,
            como se fosse um app.
          </p>

          <ul>
            <li>✔ Acesso rápido</li>
            <li>✔ Mais leve e prático</li>
            <li>✔ Use como aplicativo</li>
          </ul>

          <InstallButton />


        </div>

        {/* SOBRE */}
        <div className={styles.section}>
          <h2>O que é o Fohattech?</h2>
          <p>
            O Fohattech é uma coleção de ferramentas online criadas para facilitar tarefas do dia a dia.
            Tudo funciona direto no navegador, sem instalação.
          </p>
        </div>

        {/* FERRAMENTAS */}
        <div className={styles.section}>
          <h2>Ferramentas disponíveis</h2>

          <div className={styles.cards}>

            <div className={styles.card}>
              <h3>Memory Lab</h3>
              <p>
                Treine sua memória com desafios de sequência numérica e testes cognitivos progressivos.
              </p>
              <Link to="/tools/memory-lab">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Redimensionar para Instagram</h3>
              <p>
                Ajuste imagens para feed, stories e reels no tamanho ideal sem perder qualidade.
              </p>
              <Link to="/tools/instagram-resize">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Gerador de QR Code</h3>
              <p>
                Crie QR Codes personalizados para links, textos e Wi-Fi. Baixe em PNG ou PDF.
              </p>
              <Link to="/tools/qr-code">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>ArrowForge</h3>
              <p>Copie setas prontas (→ ↑ ↓ ⇄ ➜) para usar em textos, sites e redes sociais.</p>
              <Link to="/tools/arrow-forge">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Image to Pixel Art</h3>
              <p>Converta imagens em pixel art para jogos e projetos criativos.</p>
              <Link to="/tools/image-to-pixel-art">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>DeckForge</h3>
              <p>Crie e personalize cartas de baralho para jogos ou impressão.</p>
              <Link to="/tools/deckforge">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Compressify</h3>
              <p>
                Permite comprimir imagens
                sem perder qualidade significativa.
              </p>
              <Link to="/tools/compressify">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Consumo de Água</h3>
              <p>
                Descubra quantos litros de água você deve beber por dia e acompanhe sua hidratação.
              </p>
              <Link to="/tools/water-intake">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Calculadora de IMC</h3>
              <p>Calcule seu índice de massa corporal rapidamente.</p>
              <Link to="/tools/imc">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>NASA por Data</h3>
              <p>Imagem do dia da NASA.</p>
              <Link to="/tools/nasa-date">Abrir</Link>
            </div>

            <div className={styles.card}>
              <h3>Pesquisa NASA</h3>
              <p>Busque imagens espaciais.</p>
              <Link to="/tools/nasa-search">Abrir</Link>
            </div>

          </div>
        </div>

        {/* BENEFÍCIOS */}
        <div className={styles.section}>
          <h2>Por que usar?</h2>
          <ul>
            <li>Sem cadastro</li>
            <li>Rápido e direto</li>
            <li>Funciona em qualquer dispositivo</li>
          </ul>
        </div>

        {/* FINAL */}
        <div className={styles.section}>
          <h2>Comece agora</h2>
          <p>Explore todas as ferramentas disponíveis.</p>

          <Link to="/ferramentas" className={styles.ctaButton}>
            Ver ferramentas
          </Link>
        </div>

      </div>
    </section>
  );
};

export default Home;